import styled from 'styled-components';

export const UnregisteredStep4Style = styled.div`
  .location-description {
    img {
      width: 16px;
      margin-top: 3px;
    }

    display: flex;
    gap: 9px;
    align-items: flex-start;
    margin-bottom: 16px;
  }
`;
